module.exports = __webpack_public_path__ + "img/img-error.6b22f90a.png";